import { getFlowSteps, handleSeviceTypes, checkForHBA } from "../../helpers"
import { getStorageItem, setStorageItem } from "../../helpers/storageManager"

let popupModule = ""
let viewplansRoute = "/viewplans"
let subscriptionRoute = "/subscription"
let updateRoute = "/update"
export const isTveLoggedInRoute = "/update"

const handleRoutePath = () => {
    let compliance = window?.app_data?.site?.settings?.compliance;
    const steps = getFlowSteps(compliance);
    return steps
}
let flowSteps = handleRoutePath()

export const dynamicConfig = (routeState, param,isSkipped,justSubscribed,currentRoute) => { // just subscribed key is not getting used
    // let state = routeState
    // if (!routeState) {
    //     outsideFlow(param,isSkipped,justSubscribed,currentRoute)
    // }
    // switch (state) {
    //     case 1:
    //         popupModule = outsideFlow(flowSteps[0],isSkipped,justSubscribed,currentRoute)
    //         break;
    //     case 2:
    //         popupModule = outsideFlow(flowSteps[1],isSkipped,justSubscribed,currentRoute)
    //         break;
    //     case 3:
    //         popupModule = outsideFlow(flowSteps[2],isSkipped,justSubscribed,currentRoute)
    //         break;
    //     case 4:
    //         popupModule = outsideFlow(flowSteps[3],isSkipped,justSubscribed,currentRoute)
    //         break;
    //     default:
    //         popupModule = outsideFlow(param,isSkipped,justSubscribed,currentRoute)
    // }
    // return popupModule

    return getRoute(isSkipped).then((nextRoute) => {
        return nextRoute
    })
}

const checkIsSubscribed = async (isSkipped,justSubscribed) => {
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    let user = AuthenticationStore?.user
    let isSubscribed = user?.isSubscribed || false
    let isUpdated = (user?.email || user?.unverifiedEmail) && (user?.unverifiedPhone || user?.phoneNumber) && true
    let isTveLoggedIn = (user?.tveProvider || user?.tveMetadata?.tveProvider) && user?.canAuthenticate ? true : false
    if (isSkipped) {
        if (isSubscribed || isTveLoggedIn) {
        if (isUpdated) return "/"
        else return updateRoute
        }else {return false}
    }
    if (!isSkipped && isTveLoggedIn && isUpdated) return "/"
    if (isSubscribed) {
        if (isUpdated) return "/"
        else return updateRoute
    }else {
        return false
    }
  }


const outsideFlow = async (routeState,isSkipped,justSubscribed,currentRoute) => {
    let param = location?.pathname
    let isAllSet = await checkIsSubscribed(isSkipped,justSubscribed)
    let state = {
        "managedevices": { routeState: false, route: "StandaloneManageDevices" },
        'appliedoffers': { routeState: false, route: "StandaloneAppliedOffer" },
        'personlizationsetup': { routeState: false, route: "StandalonePersonalization" },
        '/authentication': { routeState: flowSteps.indexOf("/authentication"), route: "/authentication" },
        '/consent': { routeState: flowSteps.indexOf("/consent"), route: "/consent" },
        '/locate': { routeState: flowSteps.indexOf("/locate"), route: "/locate" },
        '/tve': { routeState: flowSteps.indexOf("/tve"), route: "/tve" },
        '/update': { routeState: flowSteps.indexOf("/update"), route: "/update" },
        "/viewplans": { routeState: flowSteps.indexOf("/viewplans"), route: "/viewplans" },
        "/subscription": { routeState: flowSteps.indexOf("/subscription"), route: "/subscription" },
    }
    window.onload = () => {
        setStorageItem("routeState", state[param]?.routeState + 1)
    }
    window && setStorageItem("routeState", state[param]?.routeState + 1)
    let currentStep = flowSteps.indexOf(param)
    if (isAllSet) {
       return isAllSet
    }
    if (isSkipped && currentRoute == viewplansRoute & flowSteps[currentStep + 1] == subscriptionRoute) {
        if (currentStep != -1 && (currentStep + 2) < flowSteps.length) {
            return flowSteps[currentStep + 2]
        }
    }
    if (currentStep != -1 && (currentStep + 1) < flowSteps.length) {
        return flowSteps[currentStep + 1]
    }
    else {
        return "/"
    }
}

/**
 * fetch skipStatus of the selected route
 * @param string the route URL
   * @returns bool the route skip flag
 */
const validateRoute = async (selectedRoute) =>{
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    let isRedirected = getStorageItem("isRedirected")
    const user = AuthenticationStore?.user
    const isTveLoggedIn = ((user?.tveProvider || user?.tveMetadata?.tveProvider) && user?.canAuthenticate) ? true : false
    const isSubscribed = user?.isSubscribed || false
    const isUpdated = ((user?.email || user?.unverifiedEmail) && (user?.unverifiedPhone || user?.phoneNumber)) ? true : false
    const isPersonalized = user?.profiles?.[0]?.isContentPersonalizationViewed
    let routeSkipStatus = false

    // handling redirect from detail page
    let isDetailPage = isRedirected?.isDetailPage
    const onboardingFlow =  app_data?.appcmsPlatform?.navigation?.onBoarding || []
    let selectedRouteDetails = onboardingFlow.filter((route) => route.url === selectedRoute)
    let selectedRouteRequired = selectedRouteDetails[0]?.isRequired
    if (selectedRoute === '/consent') {
        selectedRouteRequired = true
    }
    if (isDetailPage && !selectedRouteRequired) {
        routeSkipStatus = true
        return routeSkipStatus
    }

    if(selectedRoute === "/tve"){
        routeSkipStatus =  isTveLoggedIn ? true : false
    }

    if(selectedRoute === "/viewplans" || selectedRoute === "/subscription"){
        let isMonetisationSkipped = false
        if (selectedRoute === "/subscription") {
            isMonetisationSkipped = localStorage.getItem('isMonetisationSkipped')
        }
        routeSkipStatus =  ((isSubscribed || isTveLoggedIn) && !(isRedirected?.isUpgradePlan)) || JSON.parse(isMonetisationSkipped) ? true : false
    }

    if(selectedRoute === "/update"){
        routeSkipStatus =  isUpdated ? true : false
    }
    
    if(selectedRoute === "/personalization"){
        routeSkipStatus = isPersonalized ? true : false
    }
    if (selectedRoute === "/locate" && user && user?.userId) {
        const isHba = await checkForHBA();
        if (isHba) routeSkipStatus =  true
    }

    return routeSkipStatus
}

/**
 * fetch next route from the flowSteps
 * @param bool the skip flag of the route
   * @returns string the next route URL
 */
const getRoute = async (isSkipped) => {
    // check the redirect case
    let isRedirected = getStorageItem("isRedirected")
    if ((isRedirected?.redirect && !isRedirected?.isDetailPage) || (isRedirected?.redirect === "FREE_LOGIN" || isRedirected?.redirect === "EMAIL_REQUIRED")) {
        if(isRedirected?.redirect === "FREE_LOGIN" || isRedirected?.redirect === "EMAIL_REQUIRED"){
            return `${isRedirected?.path}`
        }
        return isRedirected?.path
    }

    if (isRedirected?.isUpgradePlan) {
        return "viewplans?upgradeplan"
    }

    if(isRedirected?.checkForHBA){
        return "subscription"
    }

    const updateCard = JSON.parse(localStorage.getItem('updateCardStatus'));
    if (updateCard) {
        return "subscription?managecard"
    }

    // If it's not redirected case then fetch the route
    const currentRoute = window?.location?.pathname 
    const currentIndex = flowSteps?.findIndex(url => url === currentRoute)
    let nextIndex = currentIndex + 1 
    
    if (currentIndex != -1 && (nextIndex < flowSteps?.length)) {
        // handle all skip cases
        if(isSkipped){
            // case 1: skip subscription-route, if viewplan-route is skipped
            if(currentRoute == viewplansRoute && (flowSteps[currentIndex + 1] == subscriptionRoute)){
                if(currentIndex + 2 >= flowSteps?.length) return "/"
                nextIndex = currentIndex + 2
            }
        }
        let selectedNextRoute = flowSteps[nextIndex]
        
        // validate the selected route
        let routeSkipStatus = true   // default value for while loop
        while(routeSkipStatus){
            routeSkipStatus = await validateRoute(selectedNextRoute)
            // update next selected_route if skipped
            if(routeSkipStatus){
                if(nextIndex + 1  >= flowSteps?.length) {
                    if (isRedirected?.isDetailPage) {
                        return isRedirected?.path
                    }
                    if (isRedirected?.isUpgradePlan) {
                        return isRedirected?.path
                    }
                    return "/"
                }
                nextIndex++
                selectedNextRoute = flowSteps[nextIndex]
            }
        }
        return selectedNextRoute ? selectedNextRoute : "/"
    }
    else {
        return "/"
    }
}